import { Component, Input } from '@builder.io/sdk';

import { rtcCardColorField } from 'organisms/Cards/config';

import { idField } from 'utils/builder/fields';

const statFields = [
  idField,
  {
    name: 'stat',
    type: 'string',
    defaultValue: '100%',
    helperText: 'The numeric or percentage value to highlight (e.g., 100%, 250+, etc.).',
  },
  {
    name: 'description',
    type: 'longText',
    defaultValue: 'Value',
    helperText: 'Label or description for the stat (e.g., "Customer Retention").',
  },
] as const satisfies DeepReadonly<Input[]>;

const statsCardFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Here are some stats',
    helperText: 'Title for the stats card, displayed above the stat list.',
  },
  {
    name: 'stats',
    type: 'list',
    subFields: statFields,
    helperText: 'Add up to 3 stats. Each stat contains a value and description.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('stats').length > 3) {
        options.set('stats', options.get('stats').slice(0, 3));
        alert('Maximum stat count is 3. Removing excess stats.');
      }
    },
  },
  rtcCardColorField,
] as const satisfies DeepReadonly<Input[]>;

const statsCardConfig = {
  name: 'statsCard',
  inputs: statsCardFields,
} as Component;

export type StatConfigProps = GenerateBuilder<typeof statFields>;
export type StatsCardConfigProps = GenerateBuilder<typeof statsCardFields>;

export default statsCardConfig;
